import { gql } from "@apollo/client";

export const CREATE_PACKAGE_MUTATION = gql`
  mutation CreatePackage($packageData: PackageInput!) {
    createPackage(packageData: $packageData) {
      package {
        id
        name
      }
    }
  }
`;
